import { SET_LANGUAGE } from './types';

export function setSelectedLanguage(language) {
  return {
    type: SET_LANGUAGE,
    payload: language
  };
}
